var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, useState } from 'react';
import Select from 'react-select';
/* eslint-enable import/namespace,import/named */
import { getDefaultStyles } from './utils';
import { Label, SelectWrapper } from './styles';
var CustomSelect = function (_a) {
    var styles = _a.styles, warning = _a.warning, error = _a.error, touched = _a.touched, innerRef = _a.innerRef, onChange = _a.onChange, floatingLabel = _a.floatingLabel, restProps = __rest(_a, ["styles", "warning", "error", "touched", "innerRef", "onChange", "floatingLabel"]);
    var hasError = !!error && !!touched;
    var hasWarning = !!warning && !!touched;
    var selectStyles = useMemo(function () { return styles !== null && styles !== void 0 ? styles : getDefaultStyles({ hasError: hasError, hasWarning: hasWarning }); }, [styles, hasError, hasWarning]);
    var _b = useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var handleFocus = function () { return setIsFocused(true); };
    var handleBlur = function (e) {
        var _a;
        var value = restProps.value;
        var hasValue = Array.isArray(value) ? value.length > 0 : value !== null;
        if (!hasValue) {
            setIsFocused(false);
        }
        (_a = restProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(restProps, e);
    };
    var handleChange = function (value, actionMeta) {
        setIsFocused(true);
        onChange === null || onChange === void 0 ? void 0 : onChange(value, actionMeta);
    };
    return (React.createElement(SelectWrapper, null,
        floatingLabel && React.createElement(Label, { isFloating: isFocused }, floatingLabel),
        React.createElement(Select, __assign({}, restProps, { styles: selectStyles, ref: innerRef, onFocus: handleFocus, onChange: handleChange, onBlur: handleBlur }))));
};
export default CustomSelect;
